export class CreateCustomerDto {
    name: string = '';
    email: string = '';
    phone: string = '';
    address: string = '';
    identificationField: string = '';
}